import './index.scss'
import '../../assets/scripts/jquery.fancybox.js'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiperbanner = new Swiper(".section1 .mySwiper", {
  speed: 600,
  watchOverflow: true,
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  pagination: {// 分页
    el: ".section2 .swiper-pagination",
    clickable: true,
  },
})
var swiper1 = new Swiper(".section2 .cont1 .mySwiper", {
  speed: 1000,
  slidesPerView: 2,
  slidesPerGroup : 2,
  spaceBetween: 10,
  breakpoints: { //响应式
    768: {  //当屏幕宽度大于等于768 
      slidesPerView: 3,
      slidesPerGroup : 3,
      spaceBetween: 10
    },
    1280: {  //当屏幕宽度大于等于1280
      slidesPerView: 3,
      slidesPerGroup : 3,
      spaceBetween: 20
    }
  },
  pagination: {// 分页
    el: ".section2 .cont1 .swiper-pagination",
    clickable: true,
  },
})

var swiper2 = new Swiper(".guide .mySwiper", {
  loop: true,
  speed: 800,
  spaceBetween: 10,
  autoplay: { // 自动切换
    delay: 5000,
    stopOnLastSlide: false,
    disableOnInteraction: false,
    waitForTransition: false,
    pauseOnMouseEnter: true,
  },
  pagination: {// 分页
    el: ".guide .swiper-pagination",
    clickable: true,
  },
})

var swiper3 = new Swiper(".related .mySwiper", {
  speed: 800,
  slidesPerView: 1,
  spaceBetween: 20,
  grid: '',
  // autoplay: { // 自动切换
  //   delay: 5000,
  //   stopOnLastSlide: false,
  //   disableOnInteraction: false,
  //   waitForTransition: false,
  //   pauseOnMouseEnter: true,
  // },
  breakpoints: { //响应式
    1280: {  //当屏幕宽度大于等于1280
      spaceBetween: 40,
      grid: {
        fill: 'column',
        rows: 2,
      },
    }
  },
  pagination: {// 分页
    el: ".related .swiper-pagination",
    clickable: true,
  },
})